import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no-image.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b375ef06")

_pushScopeId("data-v-b375ef06")
const _hoisted_1 = { id: "AllTalents" }
const _hoisted_2 = { class: "all-talents" }
const _hoisted_3 = { class: "all-talents-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline" }, "全てのタレント", -1)
const _hoisted_5 = { class: "all-talents-list" }
const _hoisted_6 = {
  key: 0,
  class: "all-img",
  src: _imports_0
}
const _hoisted_7 = { class: "talent-name txt txt-small" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allTalents, (allTalent, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "all-talent-box",
              onClick: ($event: any) => (_ctx.openTalent(allTalent.talentID))
            }, [
              (allTalent.mainImage === '')
                ? (_openBlock(), _createBlock("img", _hoisted_6))
                : (_openBlock(), _createBlock(_component_Imgix, {
                    key: 1,
                    class: "all-img",
                    imageUrl: allTalent.mainImage,
                    imageSize: _ctx.imageSize
                  }, null, 8, ["imageUrl", "imageSize"])),
              _createVNode("div", _hoisted_7, _toDisplayString(allTalent.formatDisplayName), 1)
            ], 8, ["onClick"]))
          }), 256))
        ])
      ])
    ])
  ]))
})